import { mapState } from 'vuex'
import { bus } from '@/consts.js'
import SvgLib from '@/components/SvgLib'

export default {
  name: 'Timeline',
  template: '#timeline-template',
  props: [
    'mobile'
  ],
  components: {
    SvgLib
  },
  data () {
    return {
      animate: false
    }
  },
  computed: {
    ...mapState({
      links: state => state.timelineLinks
    })
  },
  methods: {
    updateProgress () {
      let idx = this.links.findIndex(link => link.name === this.$route.name)
      const pathParts = this.$route.path.split('/')

      if (idx < 0 && pathParts.length === 3) {
        idx = this.links.findIndex(link => link.name === pathParts[1])
      } else if (idx < 0 && pathParts.length === 4) {
        idx = this.links.findIndex(link => link.name === pathParts[2])
      }

      let innerProgress = null
      switch (this.$route.name) {
        case 'create':
        case 'triumphrewards':
          innerProgress = 'full-25'
          break
        case 'createteam':
        case 'compete':
        case 'scouting':
          innerProgress = 'full-50'
          break
        case 'bracketrewards':
          innerProgress = 'full-66'
          break
        case 'createtickets':
        case 'lockedin':
          innerProgress = 'full-75'
          break
      }

      if (idx >= 0) {
        this.links.map(link => {
          this.$store.dispatch('deactivateTimelineLink', link)
          if (link.index < idx) {
            this.$store.dispatch('setTimelineLinkInnerProgress', { index: link.index, innerProgress: 'full-100' })
          } else if (link.index === idx && innerProgress !== null) {
            this.$store.dispatch('setTimelineLinkInnerProgress', { index: idx, innerProgress: innerProgress })
          } else {
            this.$store.dispatch('setTimelineLinkInnerProgress', { index: link.index, innerProgress: null })
          }
        })

        if (!this.links[idx].unlocked) {
          this.$store.dispatch('unlockTimelineLink', this.links[idx])
        } else {
          this.$store.dispatch('activateTimelineLink', this.links[idx])
        }
      }
    },
    closeNav (e, route) {
      if (this.$store.state.isMobile) {
        setTimeout(() => {
          bus.$emit('closeNav')
        }, 500)
      }

      if (e.currentTarget.classList.contains('clickable')) {
        this.$router.push({ path: route })
      }
    }
  },
  watch: {
    '$route' () {
      this.updateProgress()
    }
  },
  mounted () {
    this.updateProgress()

    setTimeout(() => {
      this.animate = true
    }, 500)
  }
}



// WEBPACK FOOTER //
// ./src/components/Timeline.js